import { useEffect, useState } from "react";
import { syncApiUrl } from "@cliqsuite/db";
import { AuthFrame, AuthHead } from "./AuthFrame";

/** Landing page for a "verify your email" link. Works without being signed in (e.g. opened on another device). */
export function VerifyEmailPage({ token, onContinue }: { token: string; onContinue: () => void }) {
  const [status, setStatus] = useState<"checking" | "ok" | "error">("checking");

  useEffect(() => {
    let cancelled = false;
    void fetch(syncApiUrl("/auth/verify-email"), {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then((res) => {
        if (!cancelled) setStatus(res.ok ? "ok" : "error");
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <AuthFrame>
      <div className="o-auth__form">
        {status === "checking" && <AuthHead icon="hourglass_top" tone="amber" title="Checking your link…" />}
        {status === "ok" && <AuthHead icon="mark_email_read" tone="ok" title="Email verified" sub="Your email is confirmed. You're all set." />}
        {status === "error" && (
          <AuthHead icon="link_off" title="Link invalid or expired" sub="It may have been used already. Sign in and send a new one from the banner at the top." />
        )}
        {status !== "checking" && (
          <button type="button" className="o-auth__submit" onClick={onContinue}>
            {status === "ok" ? "Go to Overview" : "Continue"}
            <span className="ms" aria-hidden="true">arrow_forward</span>
          </button>
        )}
      </div>
    </AuthFrame>
  );
}
